import api, { V2 } from './axios';

/** A service reference (slug + display name) inside a capability. */
export interface CatalogServiceRef {
  slug: string;
  name: string;
}

/** A browse category - its `services` are service slugs (resolve via serviceBySlug). */
export interface CatalogCategory {
  id: string;
  label: string;
  icon: string;
  color: string;
  services: string[];
}

export interface CatalogPath {
  id: 'A' | 'B';
  label: string;
  blurb: string;
  categories: CatalogCategory[];
}

/** Reverse-map entry: where a service appears + which onboarding capabilities produce it. */
export interface CatalogServiceEntry {
  slug: string;
  name: string;
  path_a: string[];
  path_b: string[];
  from_capabilities: string[];
}

export interface CatalogCapability {
  id: string;
  name: string;
  description: string;
  services: CatalogServiceRef[];
}

export interface CatalogCapabilityGroup {
  id: string;
  title: string;
  icon: string;
  accent: string;
  capabilities: CatalogCapability[];
}

export interface ServiceCatalog {
  version: number;
  paths: CatalogPath[];
  services: CatalogServiceEntry[];
  capability_groups: CatalogCapabilityGroup[];
}

export const catalogApi = {
  get: () => api.get<{ catalog: ServiceCatalog }>(`${V2}config/catalog/`),
};
